import { Component, OnInit, inject } from '@angular/core';
import { Observable } from 'rxjs';

import {
  CustomResultOfPaginatedListOfGetDescendantLandingPagesWithPaginationDto,
  GetDescendantLandingPagesWithPaginationDto,
  PaginatedListOfGetDescendantLandingPagesWithPaginationDto,
} from 'src/app/core/api/models';
import { LandingPagesService } from 'src/app/core/api/services';
import { EventTypes } from 'src/app/core/constants/event-types';
import { BaseIndexPageComponent } from '../../shared/base/components/base-index-page.component';
import { FormPageConfig } from './../../../core/models/form-page-config.model';
import { PageNames } from 'src/app/configs/page-names.enum';
import { BaseIndexModule } from '../../shared/base/modules/base-index.module';

@Component({
    selector: 'app-landing-page-list',
    templateUrl: './landing-page-list.component.html',
    imports: [BaseIndexModule]
})
export class LandingPageListComponent
  extends BaseIndexPageComponent
  implements OnInit
{
  //#region Properties

  pageName = PageNames.landingPageList;

  /* Binding service endpoints */
  protected currentService = inject(LandingPagesService);
  paginationApiMethodName: string = this.currentService.landingPagesGetDescendantLandingPagesWithPagination.name;
  auditApiMethodName: string = this.currentService.landingPagesGetLandingPagesAudit.name;


  modelWithPagination$: Observable<PaginatedListOfGetDescendantLandingPagesWithPaginationDto>;
  items$: Observable<Array<GetDescendantLandingPagesWithPaginationDto>>;
  formPageConfig: FormPageConfig<GetDescendantLandingPagesWithPaginationDto> =
    {};

  //#endregion

  constructor() {
    super();
  }

  ngOnInit() {
    try {
      super.ngOnInit();
      this.pageConfig.showAddBtn = false;
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.contentManagement
      );
    }
  }

  configTableColumns() {
    this.tableColumns = [
      {
        title: `${this.tableVocabs}shortUrl`,
        name: 'shortUrl',
        hasSearch: true,
        dir: 'ltr',
        wrap: true,
      },
      {
        title: this.localizer.active,
        name: 'isActive',
        type: 'boolean',
        hasSearch: true,
        wrap: true,
      },
      {
        title: this.localizer.createDate,
        name: 'created',
        hasSearch: true,
        type: 'dateTime',
        wrap: true,
      },
    ];
  }

  //#region Api

  //change isActive
  isActiveLandingPageApi(id, isActive) {
    this.unSubs();

    this.pageConfig.loading = true;

    this.currentService
      .landingPagesUpdateLandingPageIsActive({
        body: { isActive: isActive, landingPageId: id },
      })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseObserver);
  }

  //#endregion

  onIsActive(landingPageId, isActive) {
    this.isActiveLandingPageApi(landingPageId, isActive);
  }
}
